import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { errMsg, http } from '../lib/api';

const Ctx = createContext(null);

export function DemoProvider({ children }) {
  const [userId, setUserId] = useState(localStorage.getItem('demoUser') || 'USR-ADV');
  const [me, setMe] = useState(null);
  const [users, setUsers] = useState([]);
  const [version, setVersion] = useState(0);
  const [tour, setTourState] = useState(() => JSON.parse(localStorage.getItem('tour') || 'null'));

  const switchUser = useCallback((id) => {
    localStorage.setItem('demoUser', id);
    setUserId(id);
  }, []);
  const setTour = useCallback((t) => {
    localStorage.setItem('tour', JSON.stringify(t));
    setTourState(t);
  }, []);
  const bump = useCallback(() => setVersion((v) => v + 1), []);

  useEffect(() => {
    http.get('/demo/users').then((r) => setUsers(r.data)).catch(() => {});
  }, [version]);
  useEffect(() => {
    http.get('/me').then((r) => setMe(r.data)).catch(() => switchUser('USR-ADV'));
  }, [userId, version, switchUser]);

  return (
    <Ctx.Provider value={{ userId, me, users, version, switchUser, bump, tour, setTour }}>{children}</Ctx.Provider>
  );
}

export const useDemo = () => useContext(Ctx);

export function useApi(path) {
  const { version, userId } = useDemo();
  const [s, setS] = useState({ data: null, loading: true, error: null });
  const load = useCallback(() => {
    if (!path) return;
    setS((p) => ({ ...p, loading: true }));
    http.get(path)
      .then((r) => setS({ data: r.data, loading: false, error: null }))
      .catch((e) => setS({ data: null, loading: false, error: errMsg(e), status: e?.response?.status }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, version, userId]);
  useEffect(() => {
    load();
  }, [load]);
  return { ...s, reload: load };
}

export function useAction() {
  const { bump } = useDemo();
  return useCallback(async (fn, okMsg) => {
    try {
      const r = await fn();
      if (okMsg) toast.success(okMsg);
      bump();
      return r?.data ?? true;
    } catch (e) {
      toast.error(errMsg(e));
      return null;
    }
  }, [bump]);
}
